import apiClient from "@/shared/api/apiClient2";

export const getViewingTransaction = async (id) => {
  try {
    const { data } = await apiClient.get(`/viewing/transaction/${id}`);
    return data;
  } catch (e) {
    console.error("getViewingTransaction failed", e);
  }
};
